import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchDelete(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete('/tags/v1/delete/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
          },
        fetchData(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                .post('tags/v1/get', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchUpdate(ctx, queryParams){
            const formData = new FormData();
            formData.append('id', queryParams.id);
            formData.append('name', JSON.stringify(queryParams.name));
            formData.append('is_active', queryParams.is_active);
            return new Promise((resolve, reject) => {
                axios
                .post('tags/v1/update', formData)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateOrdering(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post('tags/v1/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}
